import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="11" viewBox="0 0 21 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20.42 6.9h-2.2c-1.73 0-1.17 1.95-2.83 1.95-1.65 0-.73-4.78-2.28-4.78-1.54 0-.92 5.98-2.61 5.98-1.7 0-.18-8.97-2.07-8.97-1.88 0-.5 6.91-2.31 6.91-1.3 0-.6-3.46-1.82-3.46-1.22 0-.41 2.4-2.03 2.4H.06" stroke="currentColor" /></svg>);